// extracted by mini-css-extract-plugin
export var container = "_5-0";
export var formArea = "_5-5";
export var formWrapper = "_5-4";
export var fullWidthButton = "_5-6";
export var leftPanel = "_5-1";
export var loadingSpinner = "_5-8";
export var logo = "_5-3";
export var logoLockup = "_5-2";
export var primaryActionButton = "_5-7";
export var spin = "_5-9";